import { _bridge } from './_bridge';
import appUtils from '../app/lib/appUtil';
import util from '../loader/utils/util';
import { devmode } from '../app/lib/devmode';
import api from '../app/lib/api';
import { reactsupport } from '../app/config/reactsupport';
import { pageManager } from '../loader/lib/pagemanager';
import router from '../loader/lib/router';
import { i18n } from '../loader/i18n/i18n';
import * as sdk from '../loader/sdk/sdk';
import * as iaas from '../app/models/issas'

_bridge('lib/appUtil', appUtils);
_bridge('nmc/lib/util', util);
_bridge('devmode', devmode);
_bridge('pageManager', pageManager);
_bridge('reactsupport', reactsupport);
_bridge('router', router);
_bridge('i18n', i18n);
_bridge('nmc/sdk/sdk', sdk);
_bridge('models/api', api);
_bridge('models/iaas', iaas);

export {
  sdk,
  i18n,
  router,
  appUtils,
  util,
  devmode,
  pageManager,
  reactsupport,
  api,
  iaas,
  _bridge
};
